export type ProAccessStatus =
  | "loading"
  | "not_pro"
  | "restricted"
  | "pending_admin_review"
  | "rejected"
  | "pending_subscription"
  | "ready"
  | "active";

export type IdentityVerificationStatus = "not_started" | "pending" | "approved" | "rejected";

export function computeProAccessStatus(params: {
  subscriptionRequired: boolean;
  subscriptionActive: boolean;
  profileCompleted: boolean;
  identityVerificationStatus: IdentityVerificationStatus;
}): ProAccessStatus {
  const effectiveSubscription = params.subscriptionRequired ? params.subscriptionActive : true;

  if (!effectiveSubscription) return "pending_subscription";
  if (!params.profileCompleted) return "restricted";
  if (params.identityVerificationStatus === "approved") return "active";
  return "ready";
}

export function canViewParentAnnouncements(role: string | null, subscriptionActive: boolean): boolean {
  return role !== "pro" || subscriptionActive;
}

export function canUseFamilyMessaging(role: string | null, status: ProAccessStatus): boolean {
  return role !== "pro" || status === "active";
}
